// components/ScrollToTop.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 20,   // 👈 offset for your navbar height
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}
